import React, { useCallback, useEffect, useState } from 'react';
import { defineMessage, useIntl } from 'react-intl';
import { styled } from '@linaria/react';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { Text } from '@daedalus/atlas/Text';
import vioGif from '../../../authentication/CognitoPasswordlessLoader/vio.gif';
const _exp = /*#__PURE__*/() => Flex.Column;
const Wrapper = /*#__PURE__*/styled(_exp())({
  name: "Wrapper",
  class: "w142il53",
  propsAsIs: true
});
const LoadingImage = /*#__PURE__*/styled('img')({
  name: "LoadingImage",
  class: "lx6vr5o",
  propsAsIs: false
});
const loadingMessages = [defineMessage({
  id: 'df.loadingFreezingPrice',
  defaultMessage: 'Freezing price...'
}), defineMessage({
  id: 'df.loadingHoldingRoom',
  defaultMessage: 'Holding room...'
}), defineMessage({
  id: 'df.loadingAlmostThere',
  defaultMessage: 'Almost there...'
}), defineMessage({
  id: 'df.loadingStillWorkingOnIt',
  defaultMessage: 'Still working on it...'
})];
const INTERVAL_TIMEOUT = 3000; // 3 seconds

export const LoadingIndicator = () => {
  const {
    formatMessage
  } = useIntl();
  const [current, setCurrent] = useState(0);
  const next = useCallback(() => {
    setCurrent(value => (value + 1) % loadingMessages.length);
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      next();
    }, INTERVAL_TIMEOUT);
    return () => {
      clearInterval(interval);
    };
  }, [next]);
  return <Wrapper alignItems="center" justifyContent="center">
      <LoadingImage src={vioGif} alt="loading..." />
      <Text variant="titleL">{formatMessage(loadingMessages[current])}</Text>
    </Wrapper>;
};

require("./LoadingIndicator.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./LoadingIndicator.tsx");